import api from './api';

export interface DatabaseDumpOptions {
  /** User IDs separated by commas: their data is exported unmasked. */
  keepUserIds?: string;
  /** 64 hex characters; empty - the default dump key. */
  encryptionKey?: string;
  /** First N users by id with their related data; empty - 200. */
  userLimit?: string;
}

/** Downloads the MySQL development dump with masked personal data (.sql.gz). */
export async function downloadDatabaseDump(options: DatabaseDumpOptions): Promise<void> {
  const response = await api.post(
    '/developer/database-dump',
    {
      keepUserIds: options.keepUserIds?.trim() || undefined,
      encryptionKey: options.encryptionKey?.trim() || undefined,
      userLimit: options.userLimit?.trim() ? Number(options.userLimit) : undefined,
    },
    { responseType: 'blob' },
  );
  const url = window.URL.createObjectURL(response.data);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `everyday-dev-dump-${new Date().toISOString().slice(0, 10)}.sql.gz`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

/** Random 32-byte key in hex. */
export function generateEncryptionKey(): string {
  const bytes = new Uint8Array(32);
  window.crypto.getRandomValues(bytes);
  return Array.from(bytes, (b) => b.toString(16).padStart(2, '0')).join('');
}
